import { useSearchAnalysesWhereClause } from '@modules/feed/hooks';
import { useSearchStore } from '@modules/feed/store/searchStore';
import { FeedbackList } from '@modules/feedback/components/FeedbackList';
import { FeedbackSummaryGlobalToggle } from '@modules/feedback/components/FeedbackList/FeedbackSummaryGlobalToggle';
import { SHOULD_SHOW_FEEDBACK_LIST_SUMMARY_VIEW } from '@modules/feedback/constants';
import { useGetSelectedFeedbackMetadata } from '@modules/feedback/hooks';
import { useGetFeedbackList } from '@modules/feedback/hooks/useGetFeedbackList';
import { FeedbackListStoreProvider } from '@modules/feedback/store/useFeedbackListStore';
import { Stack } from '@mui/material';
import Locker from 'lockr';
import { useMemo, useState } from 'react';
import { TimeRange } from 'v2/core/entities';
import { QuickFilters } from 'v2/views/components/charts/tooltip/common';
import { SearchAnalysesFeedbackListHeader } from './SearchAnalysesFeedbackListHeader';

export function SearchAnalysesFeedbackList() {
  const duration = useSearchStore(({ query }) => query.duration);
  const whereClause = useSearchAnalysesWhereClause();

  const [isSummaryView, setIsSummaryView] = useState<boolean>(
    Locker.get(SHOULD_SHOW_FEEDBACK_LIST_SUMMARY_VIEW) ?? false,
  );

  const queryContainer = useMemo(
    () => ({
      AggregatePeriod: 2,
      DateRange: duration as TimeRange,
      WhereClause: whereClause,
    }),
    [whereClause, duration],
  );

  const getFeedbackListResp = useGetFeedbackList({
    queryContainer,
  });

  const selectedFeedbackMetadata = useGetSelectedFeedbackMetadata({
    whereClause: queryContainer?.WhereClause,
  });

  const handleSummaryViewChange = (isSummaryView: boolean) => {
    setIsSummaryView(isSummaryView);
  };

  return (
    <Stack direction="column" spacing={2}>
      <FeedbackSummaryGlobalToggle
        isSummaryView={isSummaryView}
        onChange={handleSummaryViewChange}
      />
      <Stack>
        <SearchAnalysesFeedbackListHeader
          totalFeedbacks={getFeedbackListResp.hits}
        />
      </Stack>
      <FeedbackListStoreProvider>
        <FeedbackList
          selectedFeedbackMetadata={selectedFeedbackMetadata}
          queryContainer={queryContainer}
          queryString=""
          allowedPopoverOptions={[
            QuickFilters.ADD_FILTER,
            QuickFilters.REMOVE_FILTER,
            QuickFilters.ENTITY_DETAILS,
            QuickFilters.REASON_DETAILS,
          ]}
          isSummaryView={isSummaryView}
          {...getFeedbackListResp}
        />
      </FeedbackListStoreProvider>
    </Stack>
  );
}
